import { image } from '@gotombola/types/lib/types/base';
import useGameTypedLogo from './useGameTypedLogo';

export function useGameHeaderLogo(game: any, forcedLogo?: image) {
    return useGameTypedLogo(game, 'header', forcedLogo);
}

export default useGameHeaderLogo;
